import * as React from 'react';
import styled, { useTheme } from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { solid } from '@fortawesome/fontawesome-svg-core/import.macro';
import { Flex } from '@ui-library/flex';
import { SmallText } from '@ui-library/typography';
import { MonacoEditor } from '@components/common/codeEditor/monaco';
import { editorAutoHeight, editorDefaultFoldingLevel } from '@components/common/codeEditor/utils';
import { getErrorDetailLines, getFormattedSample } from './utils';
import { ErrorDetailsData } from './types';
import { ErrorContainer, ErrorEditor } from './styles';

const MAX_HEIGHT = 400;

interface Props {
  sample: string | object;
}

export const SampleError: React.FC<Props> = ({ sample: data }) => {
  const { type, sample } = getFormattedSample(data, true);

  return (
    <ErrorContainer data-testid="error-response-body">
      {type === 'object' ? (
        <ErrorEditor>
          <MonacoEditor
            onMount={(editor, monaco) => {
              editorAutoHeight(MAX_HEIGHT)(editor, monaco);
              editorDefaultFoldingLevel(2, MAX_HEIGHT)(editor, monaco);
            }}
            height={undefined}
            code={sample}
            readOnly
            language="json"
            hideLineNumber
          />
        </ErrorEditor>
      ) : (
        sample
      )}
    </ErrorContainer>
  );
};

const StyledText = styled(SmallText).attrs(() => {
  const theme = useTheme();
  return {
    color: theme.token.colorError,
  };
})``;

export const SampleErrorWithDetails: React.FC<{ errorDetailsData: ErrorDetailsData }> = ({
  errorDetailsData,
}) => {
  const theme = useTheme();
  const { code, response } = errorDetailsData;

  return (
    <Flex flexDirection="column" gap="0.75rem">
      {code && (
        <Flex alignItemsCenter gap="0.5rem">
          <FontAwesomeIcon icon={solid('circle-xmark')} color={theme.token.colorError} />
          <Flex flexDirection="column">
            {getErrorDetailLines(errorDetailsData).map(({ label, value }) => (
              <StyledText key={label}>
                {label}: {value}
              </StyledText>
            ))}
          </Flex>
        </Flex>
      )}
      <SampleError sample={response} />
    </Flex>
  );
};
